<template>
    <div>
        <v-btn color="error" text style="text-transform: lowercase" @click="dialog = !dialog">
            <strong>
                Cerrar sesión
            </strong>
        </v-btn>

        <v-dialog v-model="dialog" persistent max-width="400px">
            <v-card class="pa-2">
                <v-form v-model="form" ref="form" v-on:submit.prevent="logout">
                    <v-card-title>
                        <h2>Atención</h2>
                    </v-card-title>
                    <v-card-text class="px-0">
                        <v-container fluid>
                            <v-row>
                                 <p class="pb-0 mx-auto mb-0">
                                    ¿Realmente desea cerrar sesión?
                                </p>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn type="submit" text color="error" >Salir</v-btn>
                        <v-btn type="button" :color="color" @click="dialog = false" text>Cancelar</v-btn>
                    </v-card-actions>
                 </v-form>
            </v-card>
        </v-dialog>

    </div>
</template>
<script>

export default {
    data: () => ({
        dialog:false,
        form:true,
        color:"#000",
    }),

    methods:{
        logout:function(){
            axios.post('/logout').then(response => { location.reload() })
        }
    }
}
</script>
